import React from 'react';

interface InternalState {}

interface Props {}

class ContentItemsAddSourceGoogleDrive extends React.Component<
  Props,
  InternalState
> {
  public render(): JSX.Element {
    return (
      <>
        <h2>Source Google Drive</h2>
      </>
    );
  }
}

export default ContentItemsAddSourceGoogleDrive;
